"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideoutMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var styles_1 = require("./styles");
exports.SlideoutMenu = react_1.default.memo(function (_a) {
    var title = _a.title, items = _a.items, _b = _a.open, isOpen = _b === void 0 ? false : _b, onItemClick = _a.onItemClick;
    var _c = (0, react_1.useState)(isOpen), open = _c[0], setOpen = _c[1];
    var handleClick = function () { return setOpen(!open); };
    var classes = (0, styles_1.useStyles)({ open: open });
    return ((0, jsx_runtime_1.jsx)(core_1.List, __assign({ role: "menu", component: "nav", "data-testid": "slide-out-menu-list", disablePadding: true, subheader: (0, jsx_runtime_1.jsx)(core_1.ListSubheader, __assign({ "data-testid": "section-title", className: classes.sectionHeaderText, onClick: handleClick }, { children: (0, jsx_runtime_1.jsxs)(core_1.ListItem, __assign({ component: "div", className: classes.sectionHeaderContent }, { children: [(0, jsx_runtime_1.jsx)(core_1.ListItemText, { primary: title }), open ? (0, jsx_runtime_1.jsx)(icons_1.ExpandLess, {}) : (0, jsx_runtime_1.jsx)(icons_1.ExpandMore, {})] })) })), dense: true }, { children: (0, jsx_runtime_1.jsx)(core_1.Collapse, __assign({ in: open, timeout: "auto", unmountOnExit: true }, { children: (0, jsx_runtime_1.jsx)(core_1.List, __assign({ disablePadding: true, dense: true, className: classes.collapseList }, { children: items.map(function (_a) {
                    var _b = _a.permitted, permitted = _b === void 0 ? true : _b, rest = __rest(_a, ["permitted"]);
                    return permitted && ((0, jsx_runtime_1.jsx)(core_1.ListItem, __assign({ "data-testid": "section-listitem", button: true, className: classes.collapseOptions, selected: rest.selected, onClick: function (event) {
                            if (onItemClick)
                                onItemClick(event, __assign({}, rest));
                        } }, rest, { children: (0, jsx_runtime_1.jsx)(core_1.ListItemText, { primary: rest.text }) }), rest.id));
                }) })) })) })));
});
